/**
 * @file Photo related fragments.
 */

import gql from 'graphql-tag';

export const PhotoUrlTypeFieldsPhoto = gql`
  fragment PhotoUrlTypeFieldsPhoto on PhotoURLType {
    url
    width
    height
    size_code
  }
`;

export const PhotoThumbnailsPhoto = gql`
  fragment PhotoThumbnailsPhoto on Photo {
    id
    thumbnail_urls {
      ...PhotoUrlTypeFieldsPhoto
    }
  }
  ${PhotoUrlTypeFieldsPhoto}
`;

export const PhotoFavoriteDetails = gql`
  fragment PhotoFavoriteDetails on Photo {
    id
    is_favorite
  }
`;

export const AlbumPhotoFavoriteDetails = gql`
  fragment AlbumPhotoFavoriteDetails on AlbumPhoto {
    id
    favorite_photos {
      total
    }
  }
`;
